export var ButtonDropdown = (window.ButtonDropdown = new Class({
   Implements: [Options],
   options: {
      items: [],
   },
   dropdownEl: null,
   initialize: function(el, options) {
      this.setOptions(options);

      el.addEvents({
         click: this.toggleDropdown.bind(this),
      });

      this.buttonEl = el;

      var template = window.hbsTemplates('BUTTON_DROPDOWN_HBS');
      this.dropdownEl = template(this.options);
      el.getParent('body').adopt(this.dropdownEl);
   },
   showDropdown: function(ev, el) {
      ev.preventDefault();

      var buttonPosition = this.buttonEl.getPosition();
      var buttonDims = this.buttonEl.getComputedSize();

      this.dropdownEl.setPosition({
         x: buttonPosition.x,
         y: buttonPosition.y + buttonDims.height + 6,
      });

      this.buttonEl.addClass('active');

      this.dropdownEl.show();

      // Bind an event to the whole window to allow closing the dropdown by
      // clicking outside the container.
      window.addEvent(
         'click',
         function(ev) {
            var el = ev.target;
            if (
               el != this.buttonEl &&
               el != this.dropdownEl &&
               el.getParent() != this.buttonEl &&
               el.getParent('.button-dropdown-list') === null
            ) {
               this.hideDropdown(ev, el);
            }
         }.bind(this)
      );
   },

   hideDropdown: function(ev, el) {
      this.dropdownEl.hide();
      this.buttonEl.removeClass('active');
      window.removeEvent('click');
   },

   toggleDropdown: function(ev, el) {
      if (this.buttonEl.hasClass('active')) {
         this.hideDropdown(ev, el);
      } else {
         this.showDropdown(ev, el);
      }
   },
}));
